import { render } from "./PropAliases.vue?vue&type=template&id=13459746"
import script from "./PropAliases.vue?vue&type=script&lang=js"
export * from "./PropAliases.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__